<ng-template #texto let-ruta="ruta" let-etiqueta="etiqueta" let-requerido="requerido" let-max="max" let-span="span">
  <div class="m180d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido">
    <app-ui-input [attr.id]="ruta" [ngModel]="get(ruta)" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, maxLength: max }"></app-ui-input>
  </div>
</ng-template>

<ng-template #importe let-ruta="ruta" let-etiqueta="etiqueta" let-requerido="requerido" let-span="span">
  <div class="m180d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido">
    <app-ui-input [attr.id]="ruta" [ngModel]="get(ruta)" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, type: 'number', step: '0.01', inputmode: 'decimal' }"></app-ui-input>
  </div>
</ng-template>

<ng-template #entero let-ruta="ruta" let-etiqueta="etiqueta" let-span="span">
  <div class="m180d-field" [style.grid-column]="'span ' + (span || 3)">
    <app-ui-input [attr.id]="ruta" [ngModel]="get(ruta)" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, type: 'number', step: '1', min: 0, inputmode: 'numeric' }"></app-ui-input>
  </div>
</ng-template>

<ng-template #seleccion let-ruta="ruta" let-etiqueta="etiqueta" let-opciones="opciones" let-requerido="requerido"
  let-placeholder="placeholder" let-span="span">
  <div class="m180d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido">
    <app-select [attr.id]="ruta" [ngModel]="get(ruta)" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, options: opciones, placeholder: placeholder, autoSelectSingle: !!requerido }"></app-select>
  </div>
</ng-template>

<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>person</mat-icon>
    </div>
    <div class="m180d-header-text">
      <h2 class="cf-dlg-title">{{ titulo }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitulo }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cerrar()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="saving" message="Guardando el perceptor…"></app-loading-state>

  <ng-container *ngIf="!saving && f">
    <div class="cf-dlg-body">

      <div class="m180d-alert" [class.m180d-alert--warning]="item.type === 'WARNING'"
        *ngFor="let item of mensajes(); trackBy: trackByIndex">
        <mat-icon>{{ item.type === 'WARNING' ? 'warning' : 'error' }}</mat-icon>
        <span>{{ item.message }}</span>
      </div>

      <fieldset class="m180d-fs">

        <div class="m180d-box">
          <h6 class="m180d-box__title">Datos del perceptor</h6>
          <div class="m180d-grid">
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nifPerceptor', etiqueta: 'NIF del perceptor', requerido: true, max: 9, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nifRepresentante', etiqueta: 'NIF del representante legal', max: 9, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nombre', etiqueta: 'Apellidos y nombre o denominación del perceptor', requerido: true, max: 40, span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'provinciaPerceptor', etiqueta: 'Provincia del perceptor', opciones: provinciaOptions, requerido: true, placeholder: 'Seleccionar', span: 4 }"></ng-container>
          </div>
        </div>

        <div class="m180d-box">
          <h6 class="m180d-box__title">Importes</h6>
          <div class="m180d-grid">
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'modalidad', etiqueta: 'Modalidad', opciones: modalidadOptions, requerido: true, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="importe; context: { ruta: 'base', etiqueta: 'Base de la retención', requerido: true, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="importe; context: { ruta: 'porcentaje', etiqueta: '% de retención', span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="importe; context: { ruta: 'retencion', etiqueta: 'Retención e ingreso a cuenta', requerido: true, span: 3 }"></ng-container>
            <div class="m180d-field" style="grid-column: span 3;">
              <app-select id="reintegro" [ngModel]="get('reintegro')" (ngModelChange)="set('reintegro', $event)"
                [config]="{ label: 'Reintegro de retenciones', options: sinoOptions }"></app-select>
            </div>
            <ng-container *ngTemplateOutlet="entero; context: { ruta: 'ejercicioDevengo', etiqueta: 'Ejercicio de devengo', span: 3 }"></ng-container>
          </div>
        </div>

        <div class="m180d-box">
          <h6 class="m180d-box__title">Inmueble</h6>
          <div class="m180d-grid">
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'situacionInmueble', etiqueta: 'Situación del inmueble', opciones: situacionOptions, requerido: true, placeholder: 'Seleccionar', span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'referenciaCatastral', etiqueta: 'Referencia catastral', max: 20, span: 6 }"></ng-container>

            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'tipoVia', etiqueta: 'Tipo de vía', opciones: tipoViaOptions, placeholder: 'Seleccionar', span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nombreVia', etiqueta: 'Nombre de la vía pública', max: 50, span: 9 }"></ng-container>

            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'tipoNumeracion', etiqueta: 'Tipo de numeración', opciones: tipoNumeracionOptions, placeholder: 'Seleccionar', span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'numeroCasa', etiqueta: 'Número de casa', max: 5, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'calificador', etiqueta: 'Calificador del número', max: 3, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'bloque', etiqueta: 'Bloque', max: 3, span: 3 }"></ng-container>

            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'portal', etiqueta: 'Portal', max: 3, span: 2 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'escalera', etiqueta: 'Escalera', max: 3, span: 2 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'planta', etiqueta: 'Planta o piso', max: 3, span: 2 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'puerta', etiqueta: 'Puerta', max: 3, span: 2 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'complemento', etiqueta: 'Complemento del domicilio', max: 40, span: 4 }"></ng-container>

            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'localidad', etiqueta: 'Localidad o población', max: 30, span: 4 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'provinciaInmueble', etiqueta: 'Provincia del inmueble', opciones: provinciaOptions, requerido: true, placeholder: 'Seleccionar', span: 4 }"></ng-container>
            <div class="m180d-field" style="grid-column: span 4;">
              <app-select id="codigoMunicipio" [ngModel]="get('codigoMunicipio')"
                (ngModelChange)="seleccionarMunicipio($event)"
                [config]="{ label: 'Municipio', options: municipiosSelect, placeholder: 'Seleccionar' }"></app-select>
            </div>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'codigoPostal', etiqueta: 'Código postal', max: 5, span: 4 }"></ng-container>
          </div>
        </div>

      </fieldset>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cerrar()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="guardar()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </ng-container>
</div>
